import { useEffect, useState } from "react";

const hex = (c, fb) => (/^[0-9a-f]{6}$/i.test(c || "") ? `#${c}` : fb);

// Highest current-season PPG among players who appeared before tip-off; ties by player id.
export function featuredPlayer(players = []) {
  return players.filter((p) => p.games > 0 && p.ppg != null)
    .sort((a, b) => b.ppg - a.ppg || String(a.id).localeCompare(String(b.id)))[0] || null;
}

// Real ESPN portrait of the top scorer; if no photo loads, only the arena background shows.
export function ArenaHero({ ctx }) {
  const p = featuredPlayer(ctx?.players);
  const [failed, setFailed] = useState(false);
  useEffect(() => setFailed(false), [p?.id]);
  if (!p || !p.photo || failed) return null;
  return (
    <div className="ra-hero" aria-hidden="true" data-testid="rotation-hero" data-player={p.id}
      style={{ "--hero-team": hex(ctx.team_color, "#168dff") }}>
      <img key={p.id} src={p.photo} alt="" onError={() => setFailed(true)} data-testid="rotation-hero-photo" />
      <div className="ra-hero-caption" data-testid="rotation-hero-caption">
        <strong>{p.name}</strong>
        <span>{p.jersey != null ? `#${p.jersey} · ` : ""}{ctx.team_code} · {p.ppg.toFixed(1)} PPG · team top scorer</span>
      </div>
    </div>
  );
}
